import Config from "../../config/main";

export function HandleLotteryGame (user, gameId, forSecondScreen, limitgroupId, tableId, openType) {
    let gameUrl,
        urlPrefix = Config.urlPrefix,
        userInfo = user;
    const url = location.search;
    let gameMode = "real";
    const urlParams = new URLSearchParams(url);
    const gameslug = urlParams.get('tableid') || tableId;
    let isDualscreen = sessionStorage.getItem("dualscreen") === "true";
    let authData = JSON.parse(sessionStorage.getItem("authData"));
    let cashdaskStatus = userInfo.loggedInByRFID || userInfo.loggedIn ? 'false' : 'true';
    let casinoToken = (userInfo.loggedInByRFID || userInfo.loggedIn) ? userInfo.authData.auth_token : authData.token; // todo get 2chars language code
    let lang = Config.swarm.languageMap[Config.env.lang] || Config.env.lang;
    casinoToken = encodeURIComponent(casinoToken);
    gameUrl = `${urlPrefix}gameid=${gameId}&language=${lang}&partnerid=${authData.pid}${gameslug ? ('&tableid=' + gameslug) : ''}&iscashdesk=${cashdaskStatus}&devicetypeid=6&platformType=2&token=${casinoToken}${openType ? `&openType=${openType}` : "" }`;
    if (isDualscreen) {
        if (forSecondScreen) {
            gameUrl += "&screenIndex=2";
            gameMode = "fun";
        } else {
            gameUrl += "&screenIndex=1";
        }
    }
    if (limitgroupId) {
        gameUrl += "&limitgroupId=" + limitgroupId;
    }
    gameUrl += "&openType=" + gameMode;
    if (!isDualscreen && forSecondScreen) { //in case one screen terminal asks for second screen video, return empty;
        gameUrl = null;
    }
    return gameUrl;
}

/**
 * @name getCasinoGameBaseUrl
 * @description returns game url
 * @param externalGameId
 * @param playType
 * @param authToken
 * @returns {string}
 */
